import DisctrictSchoolsPreview from './DisctrictSchoolsPreview.page';

export default DisctrictSchoolsPreview;